import React, { FunctionComponent, useEffect, useState } from 'react'
import { Field } from 'redux-form'
import MultiSelectCheckboxField from './multiSelectCheckboxField'
import { getApiRequest } from '../../helpers/apiHelper'

export interface AccessibleOrganizationsSelectProps {
  label: string
  name: string
}

export const AccessibleOrganizationsSelect: FunctionComponent<
  AccessibleOrganizationsSelectProps
> = ({ label, name }) => {
  const [organizations, setOrganizations] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    getApiRequest('accessible_organizations')
      .then((response) => {
        setOrganizations(response.data.organizations || [])
        setIsLoading(false)
      })
      .catch(() => setIsLoading(false))
  }, [])

  const options = organizations.map((org) => ({
    value: String(org.id),
    label: org.name_legal || org.name || org.code,
  }))

  return (
    <Field
      label={label}
      name={name}
      component={MultiSelectCheckboxField}
      options={options}
      isLoading={isLoading}
    />
  )
}

AccessibleOrganizationsSelect.displayName = 'Accessible Organizations Select';
